import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/hr-payroll/index";

export const Route = createFileRoute("/admin/_modules/hr-payroll")({
  component: Page,
});
